
export default function generateInvoiceHTML(data: any, type?: any, image?: any) {
  const createdAt = new Date(data?.created);
  const formatDate = (d: Date) => d.toLocaleDateString("en-GB");
  const formatTime = (d: Date) =>
    d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  const itemsHTML = (() => {
    const rows = data?.order_items.map(
      (item: any) => `
      <tr>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.product.code}</td>
        <td style="width: 120px; min-width: 120px; max-width: 120px; padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.product?.name}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.product?.purity}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.rate}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.weight}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.wastage}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.cut_piece}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.total_weight}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.wage}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">${item?.pote_stone}</td>
        <td style="padding: 6px; border-left: 1px solid #000; border-right: 1px solid #000; white-space: normal; word-break: break-word; line-height: 1.2em; max-height: 2.4em;">$${parseFloat(item?.grand_total).toFixed(2)}</td>
      </tr>`
    );

    const emptyRow = `
      <tr>
        ${Array(11)
        .fill(
          `<td style="padding:6px;border-left:1px solid #000;border-right:1px solid #000;">&nbsp;</td>`
        )
        .join("")}
      </tr>`;

    const paddingCount = Math.max(0, 10 - rows?.length);
    return [...rows, ...Array(paddingCount).fill(emptyRow)].join("");
  })();

  const terms = data?.toc
    ? data?.toc
      .split("\n\n")
      .map((line: string) => `<li>${line}</li>`)
      .join("")
    : `
      <li>All items once sold are not returnable.</li>
      <li>Guarantee only on gold purity.</li>
      <li>Keep receipt for warranty claims.</li>
      <li>Delivery within 7 working days.</li>
      <li>Invoice valid without signature/stamp.</li>
    `;

  return `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8" />
    <title>Tax Invoice</title>

    <style>
      @media print {
        @page { size: A4; }
        body { margin: 0; }
      }
    </style>
  </head>
  <body style="
      font-family: Arial, sans-serif; 
      margin: 0; 
      background: #fff;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    ">
    <!-- CONTENT WRAPPER (flex:1 pushes footer to bottom) -->
    <div>
      <div style=" font-size: 14px; color: #000; padding: 0.5mm;">
        <!-- Header -->
        <div style="display: flex; border: 1px solid #000; background-color: #082E1F; color:#CCA65B; align-items: center;">
          <div style="font-size: 24px; font-weight: bold; padding: 8px 12px; flex: 1;">
            TAX INVOICE ${type ? `(${type})` : ""}
          </div>
          <div style="font-size: 12px; line-height: 1.6; padding: 8px 12px; width: 220px; text-align: right;">
            <div><strong>INVOICE NO:</strong> ${data?.tracking_number}</div>
            <div><strong>DATE:</strong> ${formatDate(createdAt)}</div>
            <div><strong>TIME:</strong> ${formatTime(createdAt)}</div>
            <div><strong>SALESPERSON:</strong> ${data?.created_by.username}</div>
          </div>
        </div>

        <!-- Company Info -->
        <div style="display: flex; align-items: center; padding: 10px 0; margin-top: 16px; gap:10px;">
          <div style="width: 100px; height: 100px; display:flex; justify-content:center; align-items:center; margin-right:16px; border:1px solid #000; overflow:hidden;">
            ${image}
          </div>

          <div>
            <div style=" font-family: Algerian, 'Times New Roman', serif; font-size: 30px;">
              <span style="font-weight:bold;">BUDDHA JEWELLERY SYDNEY</span>  
              <span style="font-size: 10px;">EST: 2014</span>
            </div>
            <div>ADDRESS: 506 Princes Highway ROCKDALE NSW 2216</div>
            <div style="display:flex; justify-content:center; align-items:center; font-size:14px; font-weight:bold; margin-top:12px;">ABN: 2216 883 1874 </div>
          </div>
        </div>

        <!-- Customer Info -->
        <table style="width:100%; border-collapse:collapse; border:1px solid #000;">
          <tr>
            <td style="padding:4px 8px;">
              <strong>Customer Name:</strong> ${data?.customer?.name}<br/>
              <strong>Contact Number:</strong> ${data?.customer?.contact_number}<br/>
              <strong>Email:</strong> ${data?.customer?.email}
            </td>
            <td style="padding:4px 8px;">
              <strong>Terms of Delivery:</strong> ${data?.terms_of_delivery}
            </td>
          </tr>
        </table>

        <!-- Items Table -->
      <table style="border: 1px solid #000; border-collapse: collapse; width: 100%; table-layout: fixed; min-height: 250px;">
  <thead>
    <tr>
      <th style="border: 1px solid #000; padding: 6px; width: 8%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Code no.</th>
      <th style="border: 1px solid #000; padding: 6px; width: 15%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Particulars</th>
      <th style="border: 1px solid #000; padding: 6px; width: 7%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Purity</th>
      <th style="border: 1px solid #000; padding: 6px; width: 10%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Gold Rate per gm</th>
      <th style="border: 1px solid #000; padding: 6px; width: 10%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Net Weight (gm)</th>
      <th style="border: 1px solid #000; padding: 6px; width: 7%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Wastage (gm)</th>
      <th style="border: 1px solid #000; padding: 6px; width: 7%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">CutPiece (gm)</th>
      <th style="border: 1px solid #000; padding: 6px; width: 10%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Total Weight (gm)</th>
      <th style="border: 1px solid #000; padding: 6px; width: 8%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Making Charge</th>
      <th style="border: 1px solid #000; padding: 6px; width: 8%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Pote / Stone</th>
      <th style="border: 1px solid #000; padding: 6px; width: 10%; font-size: 12px; line-height: 1.2em; max-height: 2.4em; white-space: normal; word-break: break-word; text-align: center;">Amount</th>
    </tr>
  </thead>
  <tbody style="height: 120px;">
    ${itemsHTML || `<tr><td colspan="11" style="height: 120px;"></td></tr>`}
  </tbody>
</table>

        <!-- Totals + Terms -->
        <div style="display: flex; gap:10px;">
          
          <div style="width:60%; ">
            <h4>Terms and Conditions</h4>
            <ol style="font-size:10px;">${terms}</ol>
          </div>

          <table style="width:40%; height:100px; border-collapse:collapse;">
            <tr>
              <td style="border:1px solid #000; padding:6px;">Total</td>
              <td style="border:1px solid #000; padding:6px; text-align:right;">
                $${parseFloat(data?.sub_total).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td style="border:1px solid #000; padding:6px;">GST (10%)</td>
              <td style="border:1px solid #000; padding:6px; text-align:right;">
                $${parseFloat(data?.total_gst).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td style="border:1px solid #000; padding:6px;">
                Discount (${parseFloat(data?.discount ?? "0").toFixed(0)}${data?.discount_type === "amount" ? "$" : "%"})
              </td>
              <td style="border:1px solid #000; padding:6px; text-align:right;">
                $${parseFloat(data?.discount_amount).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td style="border:1px solid #000; padding:6px; background:#082E1F; color:#CCA65B; font-weight:bold;">
                Grand Total
              </td>
              <td style="border:1px solid #000; padding:6px; background:#082E1F; color:#CCA65B; font-weight:bold; text-align:right;">
                $${parseFloat(data?.grand_total).toFixed(2)}
              </td>
            </tr>
          </table>
        </div>

      </div>
    </div>

    <!-- FOOTER (NOW FIXED TO BOTTOM) -->
    <footer style="margin-top:auto; text-align:center; padding:10px 0;">
      <div style="font-weight:bold; color:red; text-decoration:underline; font-size:20px; margin-bottom:12px;">
       Celebrating 10 years Serving the Nepalese Community in Australia
      </div>
      <div>Phone: 02-95998890 / 0466210826 / 0405605440 | Buddha.jewellery@hotmail.com</div>
    </footer>

  </body>
</html>`;
}
